<script setup lang="ts">
import { useTenant } from '@/composables/useTenant';
import CoachDashboard from '@/views/dashboard/CoachDashboard.vue';
import PlayerDashboard from '@/views/dashboard/PlayerDashboard.vue';
import ParentDashboard from '@/views/dashboard/ParentDashboard.vue';

const { currentUser } = useTenant();
</script>

<template>
  <div class="space-y-6">
    <!-- Render Dashboard by Active Authenticated Role -->
    <PlayerDashboard v-if="currentUser.role === 'PLAYER'" />
    <ParentDashboard v-else-if="currentUser.role === 'PARENT' || currentUser.role === 'GUARDIAN'" />
    <CoachDashboard v-else />
  </div>
</template>
